import "./style.css";

import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";

import { ApiError, api, errorMessage } from "../../api/client";
import { useAuth } from "../../auth/AuthContext";
import { CommentForm, CommentList } from "../Comments/Comments";
import PostMedia from "../Post/PostMedia";
import TopNavBar from "../TopNavBar/TopNavBar.js";

function PhotoGrid({ photos }) {
  if (!photos?.length) return null;

  return (
    <div className="photo-grid">
      {photos.map((photo) => (
        <div key={photo.photo_guid} className="grid-item">
          <PostMedia photo={photo} className="post-media" />
          {photo.description && (
            <p className="photo-caption">{photo.description}</p>
          )}
        </div>
      ))}
    </div>
  );
}

function PostBody({ post }) {
  const { session } = useAuth();
  const [comments, setComments] = useState(post.comment_set);
  const isMine = post.member.member_guid === session.member.member_guid;

  return (
    <main>
      <div className="grid-item">
        <div className="item-content">
          <h4>
            {post.member.first_name} {post.member.last_name} — {post.tidy_date}
          </h4>
          <h3>{post.title}</h3>
          {/* dangerouslySetInnerHTML mirrors the Django |safe filter */}
          <div dangerouslySetInnerHTML={{ __html: post.content }} />
          {isMine && (
            <div className="interaction-bar">
              <Link to={`/edit/${post.post_guid}`} className="interaction-button">
                Edit Post
              </Link>
            </div>
          )}
        </div>
      </div>

      <PhotoGrid photos={post.photo_set} />

      <div className="grid-item">
        <div className="item-content">
          <h4 className="comment-heading">Comments</h4>
          <CommentForm postGuid={post.post_guid} onCommentsChanged={setComments} />
          <CommentList comments={comments} onCommentsChanged={setComments} />
        </div>
      </div>
    </main>
  );
}

export default function SinglePost() {
  const { postGuid } = useParams();
  const { session } = useAuth();

  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    api
      .get(`/family/posts/${postGuid}/`, session.token)
      .then(setPost)
      .catch((err) =>
        setError(
          // posts outside your families 404 too
          err instanceof ApiError && err.status === 404
            ? "This post doesn't exist or isn't shared with your families."
            : errorMessage(err),
        ),
      )
      .finally(() => setLoading(false));
  }, [postGuid, session.token]);

  return (
    <>
      <TopNavBar />
      {loading && (
        <div className="status-container">
          <p>Loading post…</p>
        </div>
      )}
      {error && (
        <div className="status-container error">
          <p>{error}</p>
        </div>
      )}
      {post && <PostBody key={post.post_guid} post={post} />}
    </>
  );
}
